<template>
  <div class="common-breadcrumb">
    <b-breadcrumb :items="items"></b-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'CommonBreadcrumb',
  computed: {
    items() {
      let breadcrumb = [];
      this.$route.matched.forEach((route) => {
        breadcrumb.push({
          text: route.meta.text,
          to: route.path,
        });
      });
      return breadcrumb;
    },
  },
};
</script>

<style scoped>
</style>
